import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-card-item',
  templateUrl: 'rmt-card-item.html'
})
export class RmtCardItemComponent {
  @Input() index;
  @Input() itemId;
  @Input() hideSeperator = false;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-card-item/rmt-card-item.ts